import { render, staticRenderFns } from "./CardsIndex.vue?vue&type=template&id=6c25757c"
import script from "./CardsIndex.vue?vue&type=script&lang=js"
export * from "./CardsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports